import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from, of } from 'rxjs'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { BusinessTypeApiService } from 'src/api/business-type'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createBusinessType, createBusinessTypeFailure, createBusinessTypeSuccess, loadBusinessTypes, loadBusinessTypesFailure, loadBusinessTypesSuccess, updateBusinessType, updateBusinessTypeFailure, updateBusinessTypeSuccess } from './business-types.actions'

@Injectable()
export class BusinessTypeEffects {
  private actions$ = inject(Actions)
  private BusinessTypeApi = inject(BusinessTypeApiService)
  private toaster = inject(ToasterService)


  loadBusinessTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadBusinessTypes),
    switchMap(() =>
      from(this.BusinessTypeApi.list({ limit: Number.MAX_SAFE_INTEGER })).pipe(
        map(({ data }) => loadBusinessTypesSuccess({ businessTypes: data })),
        catchError(error => {
          console.error('Unable to fetch businessTypes', error)
          this.toaster.error('Unable to fetch businessTypes', error)
          return of(loadBusinessTypesFailure({ error }))
        })))))

  createBusinessType$ = createEffect(() => this.actions$.pipe(
    ofType(createBusinessType),
    tap(() => this.toaster.progress('Creating business type...')),
    switchMap(action =>
      from(this.BusinessTypeApi.create(action.businessType)).pipe(
        map(res => createBusinessTypeSuccess({ businessType: res.data })),
        tap(() => this.toaster.success('Business type created successfully.')),
        catchAndLog(this.toaster, 'Unable to create business type', createBusinessTypeFailure
      )))))

  updateBusinessType$ = createEffect(() => this.actions$.pipe(
    ofType(updateBusinessType),
    tap(() => this.toaster.progress('Updating business type...')),
    switchMap(action =>
      from(this.BusinessTypeApi.update(action.id, action.businessType)).pipe(
        map(res => updateBusinessTypeSuccess({ businessType: res.data })),
        tap(() => this.toaster.success('Business type updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update business type', updateBusinessTypeFailure
      )))))
}
